<template lang="pug">
v-card.elevation-1
  .d-flex
    .flex-1
      v-card-title.pa-2.pl-4.font-size-16
        span.font-weight-700 Total de tickets
        span.font-weight-700.primary--text  &nbsp;{{tipo}}&nbsp;
        span.font-weight-700  pendientes por asesor
      v-card-subtitle.pb-3.font-size-12.grey--text Listado general de todos los tickets pendientes atencion
    v-btn.ma-2( color="info"  small  @click="fetchTicketsPorAnio()")
      v-icon sync
      | Actualizar
  .d-flex.fd-column
    .d-flex.ml-3.mb-2
      .d-flex.mx-2
        v-select(v-model='year' solo :items="years" :disabled="isLoading"   label='Periodo'  dense hide-details @change="fetchTicketsPorAnio()")
      .d-flex.mx-2(v-if="tipoArea")
        v-select(v-model='tipoArea' solo :items="['taller', 'campo', 'sin asignacion']" :disabled="isLoading"   label='Area'  dense hide-details @change="fetchTicketsPorAnio()")
    v-data-table(
      :headers='headers'
      dense
      item-key="codigo"
      :items='lista'
      hide-default-footer
      :loading="isLoading",
      disable-pagination
    )
    Pie-Chart(
      v-if="renderChart"
      :pendientes="valuesPendientes"
      :resueltos="valuesResueltos"
      ref="lineChart"
    )
</template>
<script>
import PieChart from './c_chart_pie_tickets_pendientes_por_asesor'
import { apiGet, notify } from '../util/general'
import moment from 'moment'

export default {
  name: 'c_card_chart_bar_tickets_pendientes_por_asesor',
  components : {
    PieChart
  },
  props: {
    tipo : {
      type   : String,
      default: 'garantia'
    },
    tipoArea : {
      type   : String,
      default: ''
    }
  },
  data () {
    return {
      isLoading              : false,
      renderChart            : false,
      headers                   : [
        { text: '', value: 'periodo' },
        { text: 'Ene', value: 'Ene' },
        { text: 'Feb', value: 'Feb' },
        { text: 'Mar', value: 'Mar' },
        { text: 'Abr', value: 'Abr' },
        { text: 'May', value: 'May' },
        { text: 'Jun', value: 'Jun' },
        { text: 'Jul', value: 'Jul' },
        { text: 'Ago', value: 'Ago' },
        { text: 'Set', value: 'Set' },
        { text: 'Oct', value: 'Oct' },
        { text: 'Nov', value: 'Nov' },
        { text: 'Dic', value: 'Dic' }
      ],
      valuesPendientes : [],
      valuesResueltos : [],
      lista : [],
      year : moment().year(),
      years : [2022, 2021]
    }
  },
  created () {
    var vm = this;
    if (!vm.years.includes(moment().year())) {
      vm.years.unshift(moment().year())
    }
    vm.fetchTicketsPorAnio()
  },
  methods : {
    fetchTicketsPorAnio () {
      var vm = this
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obtener listado de tickets...' })
      vm.lista = []
      vm.valuesPendientes = []
      vm.valuesResueltos = []
      var obj = {
        tipoTicket           : vm.tipo,
        year           : vm.year,
        tipoArea        : vm.tipoArea
      }
      apiGet(vm, '/ticket/pendientes/count/with/asesor', obj, function (data) {
        vm.lista.push({ periodo : 'Resueltos', ...data.data.resueltos })
        vm.lista.push({ periodo : 'Pendientes', ...data.data.pendientes })
        vm.lista.push({ periodo : 'TOTAL', ...data.data.totales })

        for (var i = 0; i < Object.keys(data.data.pendientes).length; i++) {
          vm.valuesPendientes.push(data.data.pendientes[Object.keys(data.data.pendientes)[i]])
        }
        for (var j = 0; j < Object.keys(data.data.resueltos).length; j++) {
          vm.valuesResueltos.push(data.data.resueltos[Object.keys(data.data.resueltos)[j]])
        }
        vm.reRenderChart()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', { isProceso : false })
      })
    },
    reRenderChart () {
      var vm = this
      vm.renderChart = false
      vm.$nextTick(() => {
        vm.renderChart = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// c_card_chart_bar_tickets_pendientes_por_asesor.vue?0f615171